import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Localization time
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';

// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { ZakazkyProvider } from './services/zakazkyContext';
import { PartieProvider } from './services/partieContext';
import { UserProvider } from './services/userContext';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ScrollToTop />
            <StyledChart />
            <UserProvider>
              <PartieProvider>
                <ZakazkyProvider>
                  <Router />
                </ZakazkyProvider>
              </PartieProvider>
            </UserProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
